import React from 'react';
import './App.css';
import OmdbMovie from './OmdbMovie';

const App = () => {
    
    return(
        <>
        <OmdbMovie />
        </>
    );
}

export default App; 